import styled from 'styled-components';

export const StyledLoading = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255, 0.8);
  font-weight: bold;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  z-index: 999;

  .text {
    background: #fff;
    padding: 20px 0;
    width: 100%;
    font-size: ${props => props.theme.fontSizes.large};
    text-align: center;
  }

  .icon {
    img {
      height: 100px;
    }
  }
`
